import { useState } from 'react'

const useHover = () => {
   const [isHovered, setIsHovered] = useState<boolean>(false)
   const handleMouseEnter = (): void => setIsHovered(true)
   const handleMouseLeave = (): void => setIsHovered(false)

   return {
      isHovered,
      handleMouseEnter,
      handleMouseLeave
   }
}

export default useHover
